import { useEffect, useState } from 'react';

// @mui
import { Container, Typography, IconButton, Tooltip } from '@mui/material';

import { useTranslation } from 'react-i18next';

import SnippetsGrid from '../components/snippetsGrid';
import SnippetCAEditor from '../components/snippetCA_Editor';


import { Icon as Iconify } from '@iconify/react';
import axios from 'axios';
import { ccColorDarkTeal } from '../components/helpersStyles';
import { CcTitle } from '../commonComponents/styledTexts';
// ----------------------------------------------------------------------


export default function PageSnippets() {
  const { t, i18n } = useTranslation();



  return (
    <>

      <Container maxWidth='xl'>


            <CcTitle className="mb-2" >{t('pageSnippets_title')}</CcTitle>
            {/*
          <Tooltip title="Create new snippet" placement='right' >
            <IconButton variant="contained" color='primary' onClick={createSnippet}>
              <Iconify icon="material-symbols:add-circle" width="48px" />
            </IconButton>
          </Tooltip>            
            */}

          <SnippetsGrid  />



      </Container>
    </>
  );
}
